export const AssetMeteringPeriodTypes = [
  {
    value: "minute",
    label: "Minute(s)"
  },
  {
    value: "hour",
    label: "Hour(s)"
  },
  {
    value: "day",
    label: "Day(s)"
  },
  {
    value: "month",
    label: "Month(s)"
  }
];



// WEBPACK FOOTER //
// ./src/constants/AssetMeteringPeriodTypes.js